<template>
<div class="animated fadeIn mt-5" v-if="dataLoaded">
  <form enctype="multipart/form-data" v-on:submit="validateBeforeSubmit($event,false)">
    <div class="row">
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong>Item</strong>
          </div>

          <b-form-row>
            <b-col md="6">
              <b-form-group label="Ano / Mês Inicial">
                <b-form-input type="number" step="1" min="0" name="ym" v-model="item.ym" placeholder="Ano / Mês Inicial"  v-validate="'required'" :state="validateState('ym')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('ym') }}
                </b-form-invalid-feedback>
              </b-form-group>

            </b-col>

            <b-col md="4">
              <b-form-group label="Zona">
                <b-form-input type="text" name="zone" v-model="item.zone" placeholder="Zona"  v-validate="'required'" :state="validateState('zone')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('zone') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-form-row>

          <b-form-row>
            <b-col md="3">
              <b-form-group label="Operadores">
                <b-form-input type="number" step="1" min="0" name="obj_operators" v-model="item.obj_operators" placeholder="Operadores"  v-validate="'required'" :state="validateState('obj_operators')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('obj_operators') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="SumTop10">
                <b-form-input type="number" step="1" min="0" name="obj_sumtop10" v-model="item.obj_sumtop10" placeholder="SumTop10"  v-validate="'required'" :state="validateState('obj_sumtop10')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('obj_sumtop10') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="Webshop">
                <b-form-input type="number" step="1" min="0" name="obj_webshop" v-model="item.obj_webshop" placeholder="Webshop"  v-validate="'required'" :state="validateState('obj_webshop')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('obj_webshop') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="UFS">
                <b-form-input type="number" step="1" min="0" name="obj_ufs" v-model="item.obj_ufs" placeholder="UFS"  v-validate="'required'" :state="validateState('obj_ufs')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('obj_ufs') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="Spreads">
                <b-form-input type="number" step="1" min="0" name="obj_spreads" v-model="item.obj_spreads" placeholder="Spreads"  v-validate="'required'" :state="validateState('obj_spreads')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('obj_spreads') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="NPS Top10 UFS">
                <b-form-input type="number" step="1" min="0" name="obj_nps_top10_ufs" v-model="item.obj_nps_top10_ufs" placeholder="NPS Top10 UFS"  v-validate="'required'" :state="validateState('obj_nps_top10_ufs')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('obj_nps_top10_ufs') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="NPS Top10 Spreads">
                <b-form-input type="number" step="1" min="0" name="obj_nps_top10_spreads" v-model="item.obj_nps_top10_spreads" placeholder="NPS Top10 Spreads"  v-validate="'required'" :state="validateState('obj_nps_top10_spreads')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('obj_nps_top10_spreads') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-form-row>



          <div slot="footer">
            <div class="row">
              <div class="col-sm-3">
                <router-link :to="{name:'ws_objectives.index'}" size="sm" variant="danger"><i class="fa fa-ban"></i> Cancelar</router-link>

              </div>
              <div class="col-sm-9 text-right">
                <b-button type="submit" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar</b-button>
                <b-button type="button" v-on:click="validateBeforeSubmit($event,true)" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar e fechar</b-button>
              </div>
            </div>
          </div>
        </b-card>


      </b-col>
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong>Debug </strong>
          </div>
          <pre>{{ item }}</pre>

        </b-card>
      </b-col>
      <!--/.col-->

    </div>
  </form>

</div>
</template>

<script>
import lists from '@/components/States.js'
export default {
  name: 'BestofObjectiveEdit',
  props: ['id'],
  components: {  },
  data() {
    return {
      lists: lists,
      dataLoaded: false,
      item: {
        ym: '',
        zone: '',
        obj_operators: 0,
        obj_sumtop10: 0,
        obj_webshop: 0,
        obj_ufs: 0,
        obj_spreads: 0,
        obj_nps_top10_ufs: 0,
        obj_nps_top10_spreads: 0,
      }
    }
  },
  methods: {
    selectDealer(e) {
      this.item.dealer_id = e.item.id
      this.item.dealer.data = e.item
    },
    selectZone(e) {
      this.item.zone = e.item.zone
      this.$refs.dealersModal.hide()
    },
    validateBeforeSubmit(evt, close) {
      evt.preventDefault()
      console.log('check validation')
      this.$validator.validateAll().then((result) => {
        console.log('validation results:', result)
        if (result) {
          console.log('all fields ok. submit')
          this.submit(evt, close)
          return
        }
        this.$bvToast.toast(`Tem campos inválidos`, { autoHideDelay: 5000, variant: 'danger', solid: true })
      })
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref)
      }
      return null
    },
    submit(e, close) {
      e.preventDefault()
      var data = {
        data: this.item
      }
      if (this.item.id) {
        this.axios.put('stars/ws_objectives' + '/' + this.item.id, data)
          .then(response => {
            this.item = response.data.data
            this.$bvToast.toast(`item gravado com sucesso`, { autoHideDelay: 5000, variant: 'success', solid: true })
            if (close) {
              this.$router.push({
                name: 'ws_objectives.index'
              })
            }
          })
          .catch(response => {
            this.$bvToast.toast(response.message, { autoHideDelay: 5000, variant: 'danger', solid: true })
          })
      } else {
        this.axios.post('stars/ws_objectives', data)
          .then(response => {
            this.item = response.data.data
            this.$bvToast.toast(`item gravado com sucesso`, { autoHideDelay: 5000, variant: 'success', solid: true })
            this.$router.push({
              name: 'ws_objectives.edit',
              params: {
                id: this.item.id
              }
            })
          })
          .catch(error => {
            this.$bvToast.toast(error.response.data.message, { autoHideDelay: 5000, variant: 'danger', solid: true })
          })
      }
    }
  },
  created() {
    var id = this.$route.params.id
    if (typeof id !== 'undefined') {
      this.axios.get('stars/ws_objectives' + '/' + id)
        .then(response => {
          this.item = response.data.data
          this.dataLoaded = true
          if(!this.item.dealer) {
            this.item.dealer = {
              data: {}
            }
          }
          if(!this.item.zone) {
            this.item.zone = {
              data: {}
            }
          }
        })
        .catch(response => {
          this.$bvToast.toast(response.message, { autoHideDelay: 5000, variant: 'danger', solid: true })
          this.$router.push({
            name: 'ws_objectives.index'
          })
        })
    } else {
      this.dataLoaded = true
    }
  }
}
</script>
